<template>
  <v-icon v-if="value" color="green darken-2">fas fa-check</v-icon>
  <v-icon v-else color="red darken-2">fas fa-times</v-icon>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    }
  }
};
</script>
